
import { Map, View } from 'ol';
import { fromLonLat } from 'ol/proj';
import { BASELAYER, survSource, survLayer, survVectorTemp } from './background_map';
import { survClick } from './geo_surv.js';
import { aoi, oepnv, aoiIn, poi } from './aoi.js';
//import { geocoder } from './geocoder';

// Erzeuge eine Karte
export let map = new Map({
    target: 'map'
});

// Wähle einen Baselayer
function layerSelector(group, input_name) {
    document.addEventListener('DOMContentLoaded', () => {
        let layerElements = document.querySelectorAll('.radio > input[name=' + input_name + ']');
        for (let layerElement of layerElements) {
            layerElement.addEventListener('change', function () {
                let layerElementValue = this.value;
                group.getLayers().forEach(function (element, index, array) {
                    let layerId = element.get("id");
                    element.setVisible(layerId === layerElementValue);

                })
            })
        }
    });
};

// Zeige Layers von aoi.js
function toggleVisibility(id) {
    const layerInput = document.getElementById(id.get("id"))

    layerInput.addEventListener('click', () => {
        if (layerInput.checked) {
            id.setVisible(true)
        }
        else {
            id.setVisible(false)
        }
    });

};

// Ausführen der Funktionen
layerSelector(BASELAYER, "backgroundMap");
map.addLayer(BASELAYER);

map.addLayer(poi);
toggleVisibility(poi);

map.addLayer(oepnv);
toggleVisibility(oepnv);

map.addLayer(aoi);
toggleVisibility(aoi);

map.addLayer(aoiIn);
toggleVisibility(aoiIn);

map.addLayer(survVectorTemp);
map.addLayer(survLayer);


// Hilfsfunktion zur Entwicklung
survLayer.getSource().on('change', function (evt) {
    const survLayer = evt.target;
    if (survSource.getState() === 'ready') {
        const numFeatures = survSource.getFeatures().length;
        console.log("Count after change: " + numFeatures);
    }
});

// Map Event
map.on('click', event => {
    survClick(map, event);
})

// Anzeigen
const start_center = fromLonLat([10.8, 54.25]);
const start_zoom = 10;

let map_view = new View({
    center: start_center,
    zoom: start_zoom
});

map.setView(map_view);
